/// <amd-module name="VSSUI/Components/Splitter/index" />

export * from "./Splitter";

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present
export { SplitterDirection, SplitterElementPosition, ISplitterProps } from "./Splitter.Props";
